export default __webpack_public_path__ + "static/petiteMaro.mobile.inspirations-31d3c2e1e48fe6f50c83669f6d7fcd44.jpg";